import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "x-navigate-layout"
};
const _hoisted_2 = {
  class: "x-layout-header"
};
const _hoisted_3 = {
  class: "x-menu-container"
};
const _hoisted_4 = {
  class: "x-main-nav-menu"
};
const _hoisted_5 = {
  class: "x-extra-nav-menu"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "header", {}, () => [_cache[0] || (_cache[0] = _createTextVNode("导航", -1))], true)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "extra-menu", {}, undefined, true)])])]);
}